var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDnv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 98 42",
    className: "the-header__logo-media",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("rect", {
    y: 16,
    width: 98,
    height: 2,
    className: "cls-1",
    style: {
      fill: "rgb(63, 156, 53)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 98,
    height: 4,
    className: "cls-2",
    style: {
      fill: "rgb(0, 53, 145)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 12,
    className: "cls-3",
    style: {
      fill: "rgb(153, 217, 240)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.14,30.02a8.4035,8.4035,0,0,0-3.4516-.6482H48.8525V42h6.8359a8.4,8.4,0,0,0,3.4516-.6483,4.7833,4.7833,0,0,0,2.2225-1.953,6.33,6.33,0,0,0,.7745-3.2749v-.8755a6.33,6.33,0,0,0-.7745-3.2749A4.7862,4.7862,0,0,0,59.14,30.02Zm.9261,6.0361a3.9171,3.9171,0,0,1-1.0945,3.0476,4.7177,4.7177,0,0,1-3.2664.9934H50.9571V31.2747h4.7481a4.8018,4.8018,0,0,1,3.2664.9681,3.9044,3.9044,0,0,1,1.0945,3.0728Z",
    className: "cls-4",
    style: {
      fill: "rgb(15, 33, 74)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.947 39.24 68.181 29.372 67.02 29.372 66.127 29.372 66.127 42 68.181 42 68.181 32.144 77.947 42 80.018 42 80.018 29.372 77.947 29.372 77.947 39.24",
    className: "cls-4",
    style: {
      fill: "rgb(15, 33, 74)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.761 29.372 90.928 39.24 86.096 29.372 83.722 29.372 90.053 42 91.686 42 98 29.372 95.761 29.372",
    className: "cls-4",
    style: {
      fill: "rgb(15, 33, 74)"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDnv);
export default __webpack_public_path__ + "static/media/dnv.cdef4f3fa70fd49d6a4a1c3c8d0337e0.svg";
export { ForwardRef as ReactComponent };